/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_Chip_OffInputs */

const vi_shop_home_chip_off = /** @type {(inputs: Shop_Home_Chip_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(đang ẩn)`)
};

/**

* @param {Shop_Home_Chip_OffInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_chip_off = /** @type {((inputs?: Shop_Home_Chip_OffInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Chip_OffInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_chip_off(inputs)
});